export const SUPPORT_EMAIL = "support@open4feedback.com";